import {
  number,
  optional,
  string,
  boolean,
  type InferOutput,
  object
} from 'valibot'

import {
  createSorterSchema,
  CHARGE_TYPES_SORT_KEYS
} from '@/features/shared/models'

export const ChargeTypesSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(CHARGE_TYPES_SORT_KEYS),
  name: optional(string()), // 項目名
  enable: optional(boolean()) // 有効/無効フラグ
})

export type ChargeTypesSearch = InferOutput<typeof ChargeTypesSearchSchema>
